import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Type from '../Type'
import L from '../L'
import Input from './Checkbox-styles'

const Checkbox = props => {
  const [id] = useState(props.id ? props.id : Math.random().toString())
  return (
    <L display="grid" ai="center">
      <Input type="checkbox" id={id} name={props.name} {...props} />
      <Type as="label" variant="body2" htmlFor={id} color="tertiary">
        {props.label}
      </Type>
    </L>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['default', 'lg']),
}

Checkbox.defaultProps = {
  id: 'Default ID',
  name: 'Default name',
  size: 'default',
  label: PropTypes.string,
}

export default Checkbox
